<template>
	<el-container>
		<el-header v-if="$slots.header" style="padding: 0px; height: 70px">
			<div class="innerTopNav">
				<slot name="header"></slot>
			</div>
		</el-header>
		<el-main
			:style="{
				padding: pagePadding,
				height: $slots.header ? 'calc(100vh - 140px)' : 'calc(100vh - 70px)',
				backgroundColor: '#fdfcff',
				overflowY: 'hidden',
			}"
		>
			<div :style="{ padding: pagePadding, height: `calc(100% - ${pagePadding})` }" class="pageContents">
				<slot name="page"></slot>
			</div>
		</el-main>
	</el-container>
</template>

<script>
export default {
	props: {
		pagePadding: {
			type: String,
			default() {
				return "20px";
			},
		},
	},
};
</script>

<style scoped>
.innerTopNav {
	height: 69px;
	border-bottom: 1px solid #e9e9eb;
}

.pageContents {
	text-align: left;
	position: relative;
}

.pageContents /deep/ h1 {
	display: block;
	font-size: 2em;
	margin-block-start: 0.67em;
	margin-block-end: 0.67em;
	margin-inline-start: 0px;
	margin-inline-end: 0px;
	margin-top: 0px;
}
</style>
